module.exports = __webpack_public_path__ + "static/media/1POLICY5.62ce3f4a.jpg";